import { ComputerStrategy } from './ComputerStrategy';
import PathMovement from './PathMovement';
import Path from './Path';
import NodeManager from './NodeManager';
import PathManager from './PathManager';

export default class ComputerStrategyBasic implements ComputerStrategy {

    public pathMovements(nodeManager: NodeManager, pathManager: PathManager): PathMovement[] {

        const pathMovements = [];

        const paths: Path[] = pathManager.all();
        const computerNodes = Phaser.Utils.Array.Shuffle(nodeManager.computerNodes());
        
        // Computer: Atack Near Enemies
        let atackBreak = false;
        for (const node of computerNodes) {
    
            const nearEnemyNodes = Phaser.Utils.Array.Shuffle(nodeManager.nearEnemyNodes(node, paths));
    
            for (const nearEnemyNode of nearEnemyNodes) {
    
                if(nearEnemyNode.counter + 2 < node.counter) { 

                    const pathMovement = pathManager.createPathMovement(node, nearEnemyNode);
                    if(pathMovement) {
                        pathMovements.push(pathMovement);
                    }

                    atackBreak = true;
                    if(atackBreak)  break;  
                }
            }
    
            if(atackBreak)  break; 
        }
        
        // Computer: Move Troups from not conflictive node
        let moveBreak = false;
        for (const node of computerNodes) {
    
            const nearEnemyNodes = Phaser.Utils.Array.Shuffle(nodeManager.nearEnemyNodes(node, paths));
            const nearAlliedNodes = Phaser.Utils.Array.Shuffle(nodeManager.nearAlliedNodes(node, paths));
    
            if(nearEnemyNodes.length == 0) {
                for (const nearAlliedNode of nearAlliedNodes) {

                    const pathMovement = pathManager.createPathMovement(node, nearAlliedNode);
                    if(pathMovement) {
                        pathMovements.push(pathMovement);
                    }
 
                    moveBreak = true;
                    if(moveBreak)  break;  
                }
            }
            
            if(moveBreak)  break; 
        }

        return pathMovements;

    }
    
}